var _defs, _g, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgregarFirmante(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.97 24.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.48.86c-2.93,0-5.31,2.38-5.31,5.31s2.38,5.31,5.31,5.31,5.31-2.38,5.31-5.31S13.41.86,10.48.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4409",
    "data-name": "Trazado 4409",
    className: "cls-1",
    d: "M10.48,22.29c-3.39-.06-6.65-1.27-9.19-3.43l-1.1-.89,1.1-.88c5.67-4.54,12.71-4.54,18.38,0l1.11.88-1.1.89c-2.55,2.16-5.81,3.38-9.2,3.43"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "22.34 9.43 22.34 5.8 20.26 5.8 20.26 9.43 16.63 9.43 16.63 11.5 20.26 11.5 20.26 15.13 22.34 15.13 22.34 11.5 25.97 11.5 25.97 9.43 22.34 9.43"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgregarFirmante);
export default __webpack_public_path__ + "static/media/agregarFirmante.868c14be616084373adb36f29c91e1b5.svg";
export { ForwardRef as ReactComponent };